/** Shopify CDN: Minification failed

Line 20:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 39:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 40:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 41:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 55:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 66:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 74:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 90:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 109:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 118:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 3 more hidden warnings

**/
/**
 * Add subscriptions to cart
 */
function addSubscriptionsToCart() {
  const c = {
    dom: {
      add_to_cart_btn: '#add-to-cart-button',
      subscription_btn_wrapper: 'subscription__btn-wrapper',
      subscription_btn: 'subscription__btn',
      single_add_to_cart_button: 'single-add-to-cart-button',
      product_form: 'product_form_id_gift',
      amount: 'amount',
      cart_drawer: 'Cart-Drawer',
    },
    cls: {
      selected: 'selected',
      active: 'active',
      open_cart: 'open-cart',
      open_cc: 'open-cc',
      loading: 'loading',
    }
  }

  const addToCartButton = document.querySelectorAll(c.dom.add_to_cart_btn);
  let selectedSellingPlanID = null;
  let selectedVariantID = null;

  /**
   * Add subscriptions to cart
   */
  function init() {
    renderButtons();
  }

  /**
   * Render buttons
   */
  function renderButtons() {
    // Buttons 
    const rechargeButtons = document.querySelectorAll(`.${c.dom.subscription_btn}`);
    if (!rechargeButtons) return;
    rechargeButtons.forEach(button => {
      // When page loads select the first button
      if (button.classList.contains(c.cls.selected)) {
        selectedSellingPlanID = button.dataset.sellingPlanId;
        selectedVariantID = button.dataset.variantId;
        selectPrice = button.dataset.price;

        addToCartButton.forEach((button) => {
          // button.disabled = false;
          const amount = button.querySelector(`.${c.dom.amount}`);
          if (!amount) return;
          amount.innerHTML = `$${selectPrice}`;
        });
      }

      // When button is clicked
      button.addEventListener('click', (e) => {
        const currentTarget = e.target;
        selectedSellingPlanID = currentTarget.dataset.sellingPlanId;
        selectedVariantID = currentTarget.dataset.variantId;
        selectPrice = currentTarget.dataset.price;

        // Remove selected class from all recharge buttons
        if (!currentTarget.classList.contains(c.cls.selected)) {
          rechargeButtons.forEach(button => {
            button.classList.remove(c.cls.selected);
          });
          // Add selected class to current recharge button
          currentTarget.classList.add(c.cls.selected);
        }

        // Enable add to cart button when a recharge button is clicked and update price
        addToCartButton.forEach((button) => {
          const amount = button.querySelector(`.${c.dom.amount}`);
          if (!amount) return;
          amount.innerHTML = `$${selectPrice}`;
        })
      });
    });

    addToCartButton.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        addToCart(selectedSellingPlanID, selectedVariantID);
      });
    })
  }

  /**
   * Add selected subscription to cart
   */
  function addToCart(sellingPlanID, variantID) {
    const submitButtons = document.querySelectorAll(`.${c.dom.single_add_to_cart_button}`);
      
    submitButtons.forEach((submitButton) => {
      if (submitButton.classList.contains(c.cls.loading)) return;
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add(c.cls.loading);
    });

    // Form
    const form = document.querySelector(`.${c.dom.product_form}`)

    let formData = new FormData(form);
    // append form data
    formData.append('id', variantID);
    formData.append('quantity', 1);
    formData.append('selling_plan', sellingPlanID);
    formData.append('sections', getSectionsToRender().map((section) => section.section));

    if (sellingPlanID && variantID) {
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
      })
      .then(response => response.json())
      .then(response => {
        renderContents(response);
      })
      .catch(error => {
        console.error('Error:', error);
      })
      .finally(() => {
        submitButtons.forEach((submitButton) => {
          submitButton.classList.remove(c.cls.loading);
          submitButton.removeAttribute('aria-disabled');
        });
      });
    } else {
      console.error('Selling Plan ID or Variant ID is missing.');
    }
  }

  /**
   * Get section inner HTML
   */
  function getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  /**
   * Get sections to render
   */
  function getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }

  /**
   *  Render contents
   */
  function renderContents(parsedState) {
    getSectionsToRender().forEach((section => {
      if (!document.getElementById(section.id)) return;
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      if (typeof CartDrawer !== 'undefined') {
        new CartDrawer();
      }
      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }

      // opens cart
      document.getElementById(c.dom.cart_drawer).classList.add(c.cls.active);
      document.body.classList.add(c.cls.open_cart);
      dispatchCustomEvent('cart-drawer:open');

      // close cart drawer when clicking outside cart card drawer
      if (!document.getElementById(c.dom.cart_drawer)) {
        document.body.classList.remove(c.cls.open_cc);
      } else if (document.getElementById(c.dom.cart_drawer)) {
        document.body.classList.add(c.cls.open_cc);
        document.body.classList.add(c.cls.open_cart);
        document.getElementById(c.dom.cart_drawer).classList.add(c.cls.active);
        dispatchCustomEvent('cart-drawer:open');
      }
    }));
  }

  return init();
}

addSubscriptionsToCart();